import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function CTASection({ testId = "global-cta" }) {
  return (
    <section
      data-testid={testId}
      className="relative py-32 md:py-44 px-6 md:px-8 overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-60 pointer-events-none" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />

      <div className="max-w-6xl mx-auto relative">
        <div className="flex flex-col items-start gap-10">
          <span className="overline">Begin</span>
          <h2 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-medium leading-[0.95] tracking-tight max-w-5xl">
            Ready to <em className="text-[#D4AF37] not-italic">elevate</em> your business?
          </h2>
          <p className="text-white/60 text-lg md:text-xl max-w-2xl leading-relaxed">
            Book a complimentary 30-minute strategy call. Walk away with a
            concrete plan — whether we work together or not.
          </p>
          <div className="flex flex-wrap items-center gap-4 mt-4">
            <Link
              to="/contact"
              data-testid="cta-book-discovery"
              className="btn-gold text-sm"
            >
              Book Your Discovery Call
              <ArrowUpRight size={16} />
            </Link>
            <Link
              to="/services"
              data-testid="cta-explore-services"
              className="btn-ghost text-sm"
            >
              Explore Services
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
